import { Button, rem, SpaceBetween, spacing, styled, TextField, useForm } from '@lessonup/ui-components';
import { TFunction } from 'i18next';
import React, { useState } from 'react';

interface AddVideoFromLinkFormInput {
  url: string;
}

interface VideoComponentSourceInputProps {
  handleAddVideo: (url: string) => string | void;
  t: TFunction;
}

export const VideoComponentSourceInput: React.FC<VideoComponentSourceInputProps> = ({ handleAddVideo, t }) => {
  const { register, watch } = useForm<AddVideoFromLinkFormInput>();
  const [urlValidationState, setUrlValidationState] = useState<string | null>(null);
  const urlInput = watch('url');

  const addVideoHandler = (url: string) => {
    const result = handleAddVideo(url);
    if (result) {
      setUrlValidationState(result);
    }
  };

  return (
    <StyledVideoComponentSourceInput>
      <SpaceBetween spacing={spacing.size8} direction="y" padding={spacing.size16}>
        <TextField
          {...register('url')}
          size="medium"
          type="url"
          placeholder={t('videoPicker.urlInputPlaceholder')}
          label={t('videoPicker.linkLabel')}
          autoComplete="off"
          endSlot={
            <Button
              buttonType="neutral"
              size="medium"
              showStroke
              onClick={() => addVideoHandler(urlInput)}
              type="submit"
              disabled={!urlInput}
            >
              {t('videoPicker.addButton')}
            </Button>
          }
          validation={urlValidationState ? { type: 'negative', message: urlValidationState } : undefined}
        />
      </SpaceBetween>
    </StyledVideoComponentSourceInput>
  );
};

const StyledVideoComponentSourceInput = styled.div`
  display: flex;
  flex-direction: column;
  width: ${rem('300px')};
`;
